import { QUERY_KEYS } from 'api/query-keys';
import { partnerInboxService } from 'partner/shared/services';
import { useMutation, useQueryClient } from 'react-query';

type MarkMessageAsUnreadParams = {
  messageId: string;
};

export const useMarkMessageAsUnread = () => {
  const mutationFn = async ({ messageId }: MarkMessageAsUnreadParams) =>
    await partnerInboxService.markInboxMessageAsUnread(messageId);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.inbox());
    },
  });
};
